/** Stable form name used by the user login screen and login saga. */
export const loginFormName = 'login';

/** Values stored by the user login form. */
export interface LoginFormValues {
    /** Username or login identifier entered by the user. */
    username: string;
    /** Password entered by the user. */
    password: string;
}

/** Default empty values for the user login form. */
export const initialLoginFormValues: LoginFormValues = {
    username: '',
    password: '',
};
